{
  "INBOX_MGMT": {
    "HEADER": "Entradas",
    "DESCRIPTION": "Un canal es el modo de comunicación que tu cliente elige para interactuar contigo. Una bandeja de entrada es donde administras interacciones para un canal específico. Puede incluir comunicaciones de diversas fuentes como correo electrónico, chat en vivo y redes sociales.",
    "LEARN_MORE": "Aprende más sobre las entradas",
    "COUNT": "{n} inbox | {n} inboxes",
    "SEARCH_PLACEHOLDER": "Search inboxes...",
    "NO_RESULTS": "No inboxes found matching your search",
    "RECONNECTION_REQUIRED": "Tu bandeja de entrada está desconectada. No recibirás mensajes nuevos hasta que lo vuelvas a autorizar.",
    "CLICK_TO_RECONNECT": "Haga clic aquí para volver a conectar.",
    "WHATSAPP_REGISTRATION_INCOMPLETE": "Your WhatsApp Business registration isn’t complete. Please check your display name status in Meta Business Manager before reconnecting.",
    "COMPLETE_REGISTRATION": "Complete Registration",
    "LIST": {
      "404": "No hay entradas adjuntas a esta cuenta."
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Elegir canal",
        "BODY": "Elija el proveedor que desea integrar con Chatwoot."
      },
      "INBOX": {
        "TITLE": "Crear bandeja de entrada",
        "BODY": "Autenticar tu cuenta y crear una bandeja de entrada."
      },
      "AGENT": {
        "TITLE": "Añadir agentes",
        "BODY": "Añadir agentes a la bandeja de entrada creada."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "¡Todo está listo!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nombre de la bandeja de entrada",
        "PLACEHOLDER": "Introduzca el nombre de la bandeja de entrada (por ejemplo: Acme Inc)",
        "ERROR": "Por favor, introduzca un nombre de bandeja de entrada válido"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nombre del sitio web",
        "PLACEHOLDER": "Introduzca el nombre de su sitio web (por ejemplo: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Al iniciar sesión, sólo tenemos acceso a los mensajes de tu Página. Tus mensajes privados nunca pueden ser accedidos por Chatwoot.",
        "CHOOSE_PAGE": "Elegir página",
        "CHOOSE_PLACEHOLDER": "Seleccione una página de la lista",
        "INBOX_NAME": "Nombre de la bandeja de entrada",
        "ADD_NAME": "Añada un nombre para su bandeja de entrada",
        "PICK_NAME": "Elija un nombre para su bandeja de entrada",
        "PICK_A_VALUE": "Elija un valor",
        "CREATE_INBOX": "Crear bandeja de entrada"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continue with Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Connect your Instagram Profile",
        "HELP": "To add your Instagram profile as a channel, you need to authenticate your Instagram Profile by clicking on 'Continue with Instagram' ",
        "ERROR_MESSAGE": "There was an error connecting to Instagram, please try again",
        "ERROR_AUTH": "There was an error connecting to Instagram, please try again",
        "NEW_INBOX_SUGGESTION": "This Instagram account was previously linked to a different inbox and has now been migrated here. All new messages will appear here. The old inbox will no longer be able to send or receive messages for this account.",
        "DUPLICATE_INBOX_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. You won’t be able to send/receive Instagram messages from this inbox anymore."
      },
      "TIKTOK": {
        "CONTINUE_WITH_TIKTOK": "Continue with TikTok",
        "CONNECT_YOUR_TIKTOK_PROFILE": "Connect your TikTok Profile",
        "HELP": "To add your TikTok profile as a channel, you need to authenticate your TikTok Profile by clicking on 'Continue with TikTok' ",
        "ERROR_MESSAGE": "There was an error connecting to TikTok, please try again",
        "ERROR_AUTH": "There was an error connecting to TikTok, please try again"
      },
      "TWITTER": {
        "HELP": "Para añadir tu perfil de Twitter como un canal, necesitas autenticar tu perfil de Twitter haciendo clic en 'Iniciar sesión con Twitter' ",
        "ERROR_MESSAGE": "Se ha producido un error al conectar a Twitter, por favor inténtelo nuevamente",
        "TWEETS": {
          "ENABLE": "Crear conversaciones de los Tweets mencionados"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal del sitio web",
        "DESC": "Cree un canal para su sitio web y comience a apoyar a sus clientes a través de nuestro widget de sitio web.",
        "LOADING_MESSAGE": "Creando Canal de Soporte al Sitio Web",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar del canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL de Webhook",
          "PLACEHOLDER": "Por favor, introduzca su URL de Webhook",
          "ERROR": "Por favor, introduzca una URL válida"
        },
        "CHANNEL_WEBHOOK_SECRET": {
          "LABEL": "Webhook Secret",
          "COPY": "Copy secret to clipboard",
          "COPY_SUCCESS": "Secret copied to clipboard",
          "TOGGLE": "Toggle secret visibility",
          "RESET_SUCCESS": "Webhook secret regenerated successfully",
          "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Dominio del sitio web",
          "PLACEHOLDER": "Introduzca el dominio de su sitio web (por ejemplo: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Cabecera de bienvenida",
          "PLACEHOLDER": "¡Hola!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Bienvenido Tagline",
          "PLACEHOLDER": "Facilitamos la conexión con nosotros. Pídanos cualquier cosa o comparte tus comentarios."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Mensaje de bienvenida del canal",
          "PLACEHOLDER": "Acme Inc normalmente responde en unas pocas horas."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Habilitar bienvenida al canal",
          "HELP_TEXT": "Envía automáticamente un mensaje de saludo cuando se crea una nueva conversación.",
          "ENABLED": "Activado",
          "DISABLED": "Deshabilitado"
        },
        "REPLY_TIME": {
          "TITLE": "Establecer tiempo de respuesta",
          "IN_A_FEW_MINUTES": "En algunos minutos",
          "IN_A_FEW_HOURS": "En unas horas",
          "IN_A_DAY": "En un día",
          "HELP_TEXT": "Éste tiempo se mostrará en el widget del chat"
        },
        "WIDGET_COLOR": {
          "LABEL": "Color del widget",
          "PLACEHOLDER": "Actualizar el color del widget usado en el widget"
        },
        "SUBMIT_BUTTON": "Crear bandeja de entrada",
        "API": {
          "ERROR_MESSAGE": "No pudimos crear un canal del sitio web, por favor inténtalo de nuevo"
        }
      },
      "TWILIO": {
        "TITLE": "Canal Twilio SMS/WhatsApp",
        "DESC": "Integre Twilio y comience a apoyar a sus clientes mediante SMS o WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Cuenta SID",
          "PLACEHOLDER": "Introduce tu SID de cuenta de Twilio",
          "ERROR": "Este campo es obligatorio"
        },
        "API_KEY": {
          "USE_API_KEY": "Usar autenticación de Clave API",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Por favor ingrese su API Key SID",
          "ERROR": "Este campo es obligatorio"
        },
        "API_KEY_SECRET": {
          "LABEL": "Clave API secreta",
          "PLACEHOLDER": "Por favor ingrese su Clave API secreta",
          "ERROR": "Este campo es obligatorio"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Servicio de Mensajes SID",
          "PLACEHOLDER": "Por favor, introduzca su SID de Servicio de Mensajes de Twilio",
          "ERROR": "Este campo es obligatorio",
          "USE_MESSAGING_SERVICE": "Usar un servicio de mensajería de Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tipo de canal",
          "ERROR": "Seleccione su tipo de canal"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token de Auth",
          "PLACEHOLDER": "Por favor ingrese su Twilio Auth Token",
          "ERROR": "Este campo es obligatorio"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nombre de la bandeja de entrada",
          "PLACEHOLDER": "Por favor, introduzca un nombre de bandeja de entrada",
          "ERROR": "Este campo es obligatorio"
        },
        "PHONE_NUMBER": {
          "LABEL": "Número telefónico",
          "PLACEHOLDER": "Por favor, introduzca el número de teléfono desde el que se enviará el mensaje.",
          "ERROR": "Por favor, proporcione un número de teléfono válido que comience con un signo `+` y no contenga espacios."
        },
        "API_CALLBACK": {
          "TITLE": "URL de devolución de llamada",
          "SUBTITLE": "Tiene que configurar la URL de devolución de llamada de mensaje en Twilio con la URL mencionada aquí."
        },
        "SUBMIT_BUTTON": "Crear Canal Twilio",
        "API": {
          "ERROR_MESSAGE": "No pudimos autenticar credenciales de Twilio, por favor inténtalo de nuevo"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Comience a apoyar a sus clientes a través de SMS.",
        "PROVIDERS": {
          "LABEL": "Proveedor de API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Ancho de banda"
        },
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID de Cuenta",
            "PLACEHOLDER": "Introduzca su ID de cuenta de Bandwidth",
            "ERROR": "Este campo es obligatorio"
          },
          "API_KEY": {
            "LABEL": "Clave de API",
            "PLACEHOLDER": "Por favor, introduzca su clave API de Bandwith",
            "ERROR": "Este campo es obligatorio"
          },
          "API_SECRET": {
            "LABEL": "API secreta",
            "PLACEHOLDER": "Por favor ingrese su Bandwith API Secret",
            "ERROR": "Este campo es obligatorio"
          },
          "APPLICATION_ID": {
            "LABEL": "ID de la aplicación",
            "PLACEHOLDER": "Introduzca su ID de cuenta de Bandwidth",
            "ERROR": "Este campo es obligatorio"
          },
          "INBOX_NAME": {
            "LABEL": "Nombre de la bandeja de entrada",
            "PLACEHOLDER": "Por favor, introduzca un nombre de bandeja de entrada",
            "ERROR": "Este campo es obligatorio"
          },
          "PHONE_NUMBER": {
            "LABEL": "Número de teléfono",
            "PLACEHOLDER": "Por favor, introduzca el número de teléfono desde el que se enviará el mensaje.",
            "ERROR": "Por favor, proporcione un número de teléfono válido que comience con un signo `+` y no contenga espacios."
          },
          "SUBMIT_BUTTON": "Crear Canal de Bandwidth",
          "API": {
            "ERROR_MESSAGE": "No pudimos autenticar credenciales de Bandwidth, por favor inténtalo de nuevo"
          },
          "API_CALLBACK": {
            "TITLE": "URL de devolución de llamada",
            "SUBTITLE": "Tienes que configurar la URL de devolución de llamada de mensaje en Bandwidth con la URL mencionada aquí."
          }
        }
      },
      "WHATSAPP": {
        "TITLE": "Canal de WhatsApp",
        "DESC": "Comience a apoyar a sus clientes mediante WhatsApp.",
        "PROVIDERS": {
          "LABEL": "Proveedor de API",
          "WHATSAPP_EMBEDDED": "WhatsApp Business",
          "TWILIO": "Twilio",
          "WHATSAPP_CLOUD": "Nube de WhatsApp",
          "WHATSAPP_CLOUD_DESC": "Quick setup through Meta",
          "TWILIO_DESC": "Connect via Twilio credentials",
          "360_DIALOG": "360dialog"
        },
        "SELECT_PROVIDER": {
          "TITLE": "Select your API provider",
          "DESCRIPTION": "Choose your WhatsApp provider. You can connect directly through Meta which requires no setup, or connect through Twilio using your account credentials."
        },
        "INBOX_NAME": {
          "LABEL": "Nombre de la bandeja de entrada",
          "PLACEHOLDER": "Por favor, introduzca un nombre de bandeja de entrada",
          "ERROR": "Este campo es obligatorio"
        },
        "PHONE_NUMBER": {
          "LABEL": "Número de teléfono",
          "PLACEHOLDER": "Por favor, introduzca el número de teléfono desde el que se enviará el mensaje.",
          "ERROR": "Por favor, proporcione un número de teléfono válido que comience con un signo `+` y no contenga espacios."
        },
        "PHONE_NUMBER_ID": {
          "LABEL": "ID de número de teléfono",
          "PLACEHOLDER": "Por favor, introduzca el ID del número de teléfono obtenido del panel de control del desarrollador de Facebook.",
          "ERROR": "Por favor, introduzca un valor válido."
        },
        "BUSINESS_ACCOUNT_ID": {
          "LABEL": "ID de cuenta de negocio",
          "PLACEHOLDER": "Por favor ingrese el ID de cuenta comercial obtenido del panel de control del desarrollador de Facebook.",
          "ERROR": "Por favor, introduzca un valor válido."
        },
        "WEBHOOK_VERIFY_TOKEN": {
          "LABEL": "Token de verificación del Webhook",
          "PLACEHOLDER": "Introduzca un token de verificación que desea configurar para los webhooks de facebook.",
          "ERROR": "Por favor, introduzca un valor válido."
        },
        "API_KEY": {
          "LABEL": "Clave de API",
          "SUBTITLE": "Configurar la clave API de WhatsApp.",
          "PLACEHOLDER": "Clave de API",
          "ERROR": "Por favor, introduzca un valor válido."
        },
        "API_CALLBACK": {
          "TITLE": "URL de devolución de llamada",
          "SUBTITLE": "Tienes que configurar la URL del webhook y el token de verificación en el portal de desarrolladores de Facebook con los valores mostrados a continuación.",
          "WEBHOOK_URL": "URL de Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Token de verificación del Webhook"
        },
        "SUBMIT_BUTTON": "Crear canal de WhatsApp",
        "EMBEDDED_SIGNUP": {
          "TITLE": "Quick setup with Meta",
          "DESC": "Use the WhatsApp Embedded Signup flow to quickly connect new numbers. You will be redirected to Meta to log into your WhatsApp Business account. Having admin access will help make the setup smooth and easy.",
          "BENEFITS": {
            "TITLE": "Benefits of Embedded Signup:",
            "EASY_SETUP": "No manual configuration required",
            "SECURE_AUTH": "Secure OAuth based authentication",
            "AUTO_CONFIG": "Automatic webhook and phone number configuration"
          },
          "LEARN_MORE": {
            "TEXT": "To learn more about integrated signup, pricing, and limitations, visit {link}.",
            "LINK_TEXT": "this link"
          },
          "SUBMIT_BUTTON": "Connect with WhatsApp Business",
          "AUTH_PROCESSING": "Authenticating with Meta",
          "WAITING_FOR_BUSINESS_INFO": "Please complete business setup in the Meta window...",
          "PROCESSING": "Setting up your WhatsApp Business Account",
          "ENABLING_CALLING": "Enabling WhatsApp Calling on your number…",
          "LOADING_SDK": "Loading Facebook SDK...",
          "CANCELLED": "WhatsApp Signup was cancelled",
          "SUCCESS_TITLE": "WhatsApp Business Account Connected!",
          "WAITING_FOR_AUTH": "Waiting for authentication...",
          "INVALID_BUSINESS_DATA": "Invalid business data received from Facebook. Please try again.",
          "SIGNUP_ERROR": "Signup error occurred",
          "AUTH_NOT_COMPLETED": "Authentication not completed. Please restart the process.",
          "SUCCESS_FALLBACK": "WhatsApp Business Account has been successfully configured",
          "MANUAL_FALLBACK": "If your number is already connected to the WhatsApp Business Platform (API), or if you’re a tech provider onboarding your own number, please use the {link} flow",
          "MANUAL_LINK_TEXT": "manual setup flow",
          "CALLING_ENABLE_FAILED": "Your WhatsApp inbox is ready, but voice calling couldn't be turned on — this number isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then turn calling on from the inbox's Calls settings."
        },
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal de WhatsApp"
        }
      },
      "VOICE": {
        "TITLE": "Voice Channel",
        "DESC": "Integrate Twilio Voice and start supporting your customers via phone calls.",
        "PHONE_NUMBER": {
          "LABEL": "Número telefónico",
          "PLACEHOLDER": "Enter your phone number (e.g. +1234567890)",
          "ERROR": "Please provide a valid phone number in E.164 format (e.g. +1234567890)"
        },
        "TWILIO": {
          "ACCOUNT_SID": {
            "LABEL": "Cuenta SID",
            "PLACEHOLDER": "Enter your Twilio Account SID",
            "REQUIRED": "Account SID is required"
          },
          "AUTH_TOKEN": {
            "LABEL": "Token de Auth",
            "PLACEHOLDER": "Enter your Twilio Auth Token",
            "REQUIRED": "Auth Token is required"
          },
          "API_KEY_SID": {
            "LABEL": "API Key SID",
            "PLACEHOLDER": "Enter your Twilio API Key SID",
            "REQUIRED": "API Key SID is required"
          },
          "API_KEY_SECRET": {
            "LABEL": "Clave API secreta",
            "PLACEHOLDER": "Enter your Twilio API Key Secret",
            "REQUIRED": "API Key Secret is required"
          }
        },
        "CONFIGURATION": {
          "TWILIO_VOICE_URL_TITLE": "Twilio Voice URL",
          "TWILIO_VOICE_URL_SUBTITLE": "Configure this URL as the Voice URL on your Twilio phone number and TwiML App.",
          "TWILIO_STATUS_URL_TITLE": "Twilio Status Callback URL",
          "TWILIO_STATUS_URL_SUBTITLE": "Configure this URL as the Status Callback URL on your Twilio phone number."
        },
        "SUBMIT_BUTTON": "Create Voice Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the voice channel"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal API",
        "DESC": "Integre con API channel y comienze a dar soporte a sus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduzca un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL de Webhook",
          "SUBTITLE": "Configure la URL donde recibirá las respuestas a los eventos.",
          "PLACEHOLDER": "URL de Webhook"
        },
        "SUBMIT_BUTTON": "Crear canal de API",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canal de Email",
        "DESC": "Integre su bandeja de entrada del email.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduzca un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "Email donde sus clientes le envían tickets de soporte",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Crear canal de email",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal de email"
        },
        "FINISH_MESSAGE": "Empieze a reenviar su emails a la siguiente dirección de email.",
        "FINISH_MESSAGE_NO_FORWARDING": "Your email inbox has been created successfully! You need to configure SMTP and IMAP credentials to send and receive emails. Without these settings, no emails will be processed.",
        "FORWARDING_ADDRESS_LABEL": "Forward emails to this address:",
        "CONFIGURE_SMTP_IMAP_LINK": "Haz clic aquí",
        "CONFIGURE_SMTP_IMAP_TEXT": " to configure IMAP and SMTP settings"
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LÍNEA",
        "DESC": "Integre con el canal LINE y comience a apoyar a sus clientes.",
        "CHANNEL_NAME": {
          "LABEL": "Nombre del canal",
          "PLACEHOLDER": "Por favor, introduzca un nombre de canal",
          "ERROR": "Este campo es obligatorio"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID del canal LINE",
          "PLACEHOLDER": "ID del canal LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secreto del canal LINE",
          "PLACEHOLDER": "Secreto del canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token de canal LINE",
          "PLACEHOLDER": "Token de canal LINE"
        },
        "SUBMIT_BUTTON": "Crear canal LINE",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal LINE"
        },
        "API_CALLBACK": {
          "TITLE": "URL de devolución de llamada",
          "SUBTITLE": "Tiene que configurar la URL del webhook en la aplicación LINE con la URL mencionada aquí."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal de Telegram",
        "DESC": "Integre con el canal de Telegram y comience a apoyar a sus clientes.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Configura el token de bot que has obtenido de Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Crear canal de Telegram",
        "API": {
          "ERROR_MESSAGE": "No pudimos guardar el canal de telegram"
        }
      },
      "AUTH": {
        "TITLE": "Elija un canal",
        "DESC": "Chatwoot soporta widgets de Live Chat, Facebook Messenger, perfiles de Twitter, WhatsApp, correos electrónicos, etc., como canales. Si quieres construir un canal personalizado, puedes crearlo usando el canal API. Para empezar, elige uno de los canales a continuación.",
        "TITLE_NEXT": "Complete the setup",
        "TITLE_FINISH": "Voilà!",
        "CHANNEL": {
          "WEBSITE": {
            "TITLE": "Sitio web",
            "DESCRIPTION": "Create a live-chat widget"
          },
          "FACEBOOK": {
            "TITLE": "Facebook",
            "DESCRIPTION": "Connect your Facebook page"
          },
          "WHATSAPP": {
            "TITLE": "WhatsApp",
            "DESCRIPTION": "Support your customers on WhatsApp"
          },
          "WHATSAPP_CALL": {
            "TITLE": "WhatsApp Call",
            "DESCRIPTION": "Take voice calls on your WhatsApp number"
          },
          "EMAIL": {
            "TITLE": "E-mail",
            "DESCRIPTION": "Connect with Gmail, Outlook, or other providers"
          },
          "SMS": {
            "TITLE": "SMS",
            "DESCRIPTION": "Integrate SMS channel with Twilio or bandwidth"
          },
          "API": {
            "TITLE": "API",
            "DESCRIPTION": "Make a custom channel using our API"
          },
          "TELEGRAM": {
            "TITLE": "Telegram",
            "DESCRIPTION": "Configure Telegram channel using Bot token"
          },
          "LINE": {
            "TITLE": "Line",
            "DESCRIPTION": "Integrate your Line channel"
          },
          "INSTAGRAM": {
            "TITLE": "Instagram",
            "DESCRIPTION": "Connect your instagram account"
          },
          "TIKTOK": {
            "TITLE": "TikTok",
            "DESCRIPTION": "Connect your TikTok account"
          },
          "VOICE": {
            "TITLE": "Voice",
            "DESCRIPTION": "Integrate with Twilio Voice"
          }
        }
      },
      "AGENTS": {
        "TITLE": "Agentes",
        "DESC": "Aquí puede agregar agentes para administrar su recién creada bandeja de entrada. Sólo estos agentes seleccionados tendrán acceso a su bandeja de entrada. Los agentes que no forman parte de esta bandeja de entrada no podrán ver o responder a los mensajes de esta bandeja de entrada cuando inicien sesión. <br> <b>PS:</b> Como administrador, si necesita acceso a todas las bandejas, debes añadirte como agente a todas las bandejas de entrada que crees.",
        "VALIDATION_ERROR": "Añade al menos un agente a tu nueva bandeja de entrada",
        "PICK_AGENTS": "Elegir agentes para la bandeja de entrada"
      },
      "DETAILS": {
        "TITLE": "Detalles de la bandeja de entrada",
        "DESC": "En el menú desplegable de abajo, selecciona la página de Facebook que quieres conectar a Chatwoot. También puede dar un nombre personalizado a su bandeja de entrada para una mejor identificación."
      },
      "FINISH": {
        "TITLE": "¡Se ha clavado!",
        "DESC": "Has terminado de integrar correctamente tu página de Facebook con Chatwoot. La próxima vez que un cliente envíe un mensaje a tu Página, la conversación aparecerá automáticamente en tu bandeja de entrada.<br>También le estamos proporcionando un script de widget que puede agregar fácilmente a su sitio web. Una vez que esto está en vivo en tu sitio web, los clientes pueden enviarle mensajes directamente desde su sitio web sin la ayuda de ninguna herramienta externa y la conversación aparecerá aquí, en Chatwoot.<br>¿Genial, eh? Bueno, estamos seguros de que intentaremos ser :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Selecciona tu proveedor de correo",
        "DESCRIPTION": "Seleccione un proveedor de correo electrónico de la siguiente lista. Si no ve a su proveedor de correo en la lista, puede seleccionar la opción de otro proveedor y proporcionar las credenciales IMAP y SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Haga clic en el botón Iniciar sesión con Microsoft para empezar. Serás redirigido a la página de inicio de sesión de correo electrónico. Una vez que aceptes los permisos solicitados, serás redirigido al paso de creación de la bandeja de entrada.",
        "EMAIL_PLACEHOLDER": "Introduzca la dirección de correo",
        "SIGN_IN": "Iniciar sesión con Microsoft",
        "ERROR_MESSAGE": "Hubo un error al conectarse a Microsoft, por favor inténtalo de nuevo"
      },
      "GOOGLE": {
        "TITLE": "Correo de Google",
        "DESCRIPTION": "Haga clic en el botón Iniciar sesión con Google para empezar. Serás redirigido a la página de inicio de sesión de correo electrónico. Una vez que aceptes los permisos solicitados, serás redirigido al paso de creación de la bandeja de entrada.",
        "SIGN_IN": "Iniciar sesión con Google",
        "EMAIL_PLACEHOLDER": "Introduzca la dirección de correo",
        "ERROR_MESSAGE": "Se ha producido un error al conectar a Google, por favor inténtelo nuevamente"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autenticándote con Facebook...",
      "ERROR_FB_LOADING": "Error al cargar Facebook SDK. Deshabilite cualquier bloqueador de anuncios e inténtelo de nuevo desde un navegador diferente.",
      "ERROR_FB_AUTH": "Algo salió mal, Por favor actualiza la página...",
      "ERROR_FB_UNAUTHORIZED": "No estás autorizado a realizar esta acción. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Asegúrate de tener acceso a la página de Facebook con control completo. Puedes leer más sobre los roles de Facebook <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "CREATING_CHANNEL": "Creando tu bandeja de entrada...",
      "TITLE": "Configurar detalles de la Bandeja de Entrada",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Añadir agentes",
      "ADD_AGENTS": "Añadiendo agentes a tu bandeja de entrada..."
    },
    "FINISH": {
      "TITLE": "¡Tu bandeja de entrada está lista!",
      "MESSAGE": "Ahora puedes colaborar con tus clientes a través de tu nuevo canal. Feliz soporte",
      "BUTTON_TEXT": "Llévame allí",
      "MORE_SETTINGS": "Más ajustes",
      "WEBSITE_SUCCESS": "Has terminado de crear un canal del sitio web. Copia el código que se muestra a continuación y pégalo en tu sitio web. La próxima vez que un cliente use el chat en vivo, la conversación aparecerá automáticamente en su bandeja de entrada.",
      "WHATSAPP_QR_INSTRUCTION": "Scan the QR code above to quickly test your WhatsApp inbox",
      "MESSENGER_QR_INSTRUCTION": "Scan the QR code above to quickly test your Facebook Messenger inbox",
      "TELEGRAM_QR_INSTRUCTION": "Scan the QR code above to quickly test your Telegram inbox"
    },
    "REAUTH": "Reautorizar",
    "VIEW": "Ver",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Configuración de bandeja de entrada actualizada correctamente",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Auto-asignación actualizada correctamente",
        "ERROR_MESSAGE": "No pudimos actualizar la configuración de la bandeja de entrada. Por favor, inténtalo de nuevo más tarde."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Nombre del remitente",
        "SUB_TEXT": "Seleccione el nombre que se muestra al cliente cuando reciba correos electrónicos de sus agentes.",
        "FOR_EG": "Por ejemplo:",
        "FRIENDLY": {
          "TITLE": "Amigable",
          "FROM": "De",
          "SUBTITLE": "Añada el nombre del agente que envió la respuesta en el nombre del remitente para que sea amistoso."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesional",
          "SUBTITLE": "Utilice sólo el nombre del negocio configurado como nombre del remitente en el encabezado del correo electrónico."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "Configura el nombre de tu negocio",
          "PLACEHOLDER": "Introduce el nombre de tu negocio",
          "SAVE_BUTTON_TEXT": "Guardar"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Activado",
        "DISABLED": "Deshabilitado"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Reopen same conversation",
        "DISABLED": "Create new conversations",
        "ENABLED_DESCRIPTION": "When a contact messages again, the previous conversation will be reopened.",
        "DISABLED_DESCRIPTION": "A new conversation will be created each time after the previous one is resolved."
      },
      "ENABLE_HMAC": {
        "LABEL": "Habilitar"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Eliminar",
      "AVATAR_DELETE_BUTTON_TEXT": "Eliminar avatar",
      "CONFIRM": {
        "TITLE": "Confirmar eliminación",
        "MESSAGE": "¿Está seguro de eliminar ",
        "PLACE_HOLDER": "Por favor, escriba {inboxName} para confirmar",
        "YES": "Sí, eliminar ",
        "NO": "No, mantenerlo "
      },
      "API": {
        "SUCCESS_MESSAGE": "Bandeja de entrada eliminada correctamente",
        "ERROR_MESSAGE": "No se pudo eliminar la bandeja de entrada. Inténtalo de nuevo más tarde.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar de bandeja de entrada eliminado correctamente",
        "AVATAR_ERROR_MESSAGE": "No se pudo eliminar el avatar de la bandeja de entrada. Inténtalo de nuevo más tarde."
      }
    },
    "TABS": {
      "SETTINGS": "Ajustes",
      "COLLABORATORS": "Colaboradores",
      "CONFIGURATION": "Configuración",
      "CAMPAIGN": "Campañas",
      "PRE_CHAT_FORM": "Pre-formulario de chat",
      "BUSINESS_HOURS": "Horarios",
      "WIDGET_BUILDER": "Constructor de Widget",
      "BOT_CONFIGURATION": "Configuración del bot",
      "ACCOUNT_HEALTH": "Account Health",
      "CSAT": "Encuestas de Satisfacción",
      "VOICE": "Voice",
      "CALLS": "Calls"
    },
    "VOICE_CONFIGURATION": {
      "ENABLE_VOICE": {
        "LABEL": "Enable Voice Calling",
        "DESCRIPTION": "Enable voice calling on this inbox. Agents will be able to make and receive phone calls."
      },
      "CREDENTIALS": {
        "DESCRIPTION": "Voice calling requires Twilio API Key credentials. These are used to generate tokens for agent voice connections."
      }
    },
    "WHATSAPP_CALLING": {
      "ENABLE": {
        "LABEL": "Enable WhatsApp Calling",
        "DESCRIPTION": "Allow agents to receive and place WhatsApp Cloud calls on this inbox. Customers can call this business number directly from WhatsApp."
      },
      "ENABLE_FAILED": "Voice calling couldn't be turned on for this number — it isn't enrolled in the WhatsApp Business Calling API yet. Reach out to Meta or your WhatsApp Business Solution Provider to onboard it, then try again.",
      "PHONE_NUMBER": {
        "LABEL": "Business phone number",
        "HELP_TEXT": "WhatsApp number that customers will call."
      },
      "HOW_IT_WORKS": {
        "LABEL": "How it works",
        "DESCRIPTION": "Calls are placed peer-to-peer between the agent's browser and Meta — no extra credentials are required. Make sure the agent's browser has microphone permission for this site."
      },
      "PERMISSION_REQUEST_BODY": {
        "LABEL": "Call permission request message",
        "HELP_TEXT": "Shown to the contact when they haven't yet consented to receive calls. Leave blank to use the default.",
        "PLACEHOLDER": "We would like to call you regarding your conversation."
      }
    },
    "CHANNEL_PREFERENCES": "Channel Preferences",
    "WIDGET_FEATURES": "Widget features",
    "ACCOUNT_HEALTH": {
      "TITLE": "Manage your WhatsApp account",
      "DESCRIPTION": "Review your WhatsApp account status, messaging limits, and quality. Update settings or resolve issues if needed",
      "GO_TO_SETTINGS": "Go to Meta Business Manager",
      "NO_DATA": "Health data is not available",
      "FIELDS": {
        "DISPLAY_PHONE_NUMBER": {
          "LABEL": "Display phone number",
          "TOOLTIP": "Phone number displayed to customers"
        },
        "VERIFIED_NAME": {
          "LABEL": "Business name",
          "TOOLTIP": "Business name verified by WhatsApp"
        },
        "DISPLAY_NAME_STATUS": {
          "LABEL": "Display name status",
          "TOOLTIP": "Status of your business name verification"
        },
        "QUALITY_RATING": {
          "LABEL": "Quality rating",
          "TOOLTIP": "WhatsApp quality rating for your account"
        },
        "MESSAGING_LIMIT_TIER": {
          "LABEL": "Messaging limit tier",
          "TOOLTIP": "Daily messaging limit for your account"
        },
        "ACCOUNT_MODE": {
          "LABEL": "Account mode",
          "TOOLTIP": "Current operating mode of your WhatsApp account"
        }
      },
      "VALUES": {
        "TIERS": {
          "TIER_250": "250 customers per 24h",
          "TIER_1000": "1K customers per 24h",
          "TIER_1K": "1K customers per 24h",
          "TIER_10K": "10K customers per 24h",
          "TIER_100K": "100K customers per 24h",
          "TIER_UNLIMITED": "Unlimited customers per 24h",
          "UNKNOWN": "Rating not available"
        },
        "STATUSES": {
          "APPROVED": "Approved",
          "PENDING_REVIEW": "Pending Review",
          "AVAILABLE_WITHOUT_REVIEW": "Available Without Review",
          "REJECTED": "Rejected",
          "DECLINED": "Declined",
          "NON_EXISTS": "Non exists"
        },
        "MODES": {
          "SANDBOX": "Sandbox",
          "LIVE": "En vivo"
        }
      },
      "WEBHOOK": {
        "TITLE": "Webhook Configuration",
        "DESCRIPTION": "Webhook URL is required for your WhatsApp Business Account to receive messages from customers",
        "ACTION_REQUIRED": "Webhook not configured",
        "REGISTER_BUTTON": "Register Webhook",
        "REGISTER_SUCCESS": "Webhook registered successfully",
        "REGISTER_ERROR": "Failed to register webhook. Please try again.",
        "CONFIGURED_SUCCESS": "Webhook configured successfully",
        "URL_MISMATCH": "Webhook URL mismatch"
      }
    },
    "SETTINGS": "Ajustes",
    "FEATURES": {
      "LABEL": "Características",
      "DISPLAY_FILE_PICKER": "Mostrar el selector de archivos en el widget",
      "DISPLAY_EMOJI_PICKER": "Mostrar el selector de emoji en el widget",
      "ALLOW_END_CONVERSATION": "Permitir a los usuarios finalizar conversaciones desde el widget",
      "USE_INBOX_AVATAR_FOR_BOT": "Usar nombre de bandeja de entrada y avatar para el bot"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script de Messenger",
      "MESSENGER_SUB_HEAD": "Coloca este botón dentro de tu etiqueta cuerpo",
      "ALLOWED_DOMAINS": {
        "TITLE": "Allowed Domains",
        "DESCRIPTION": "Restrict which websites can embed your chat widget. For security, only add domains you own and trust. Add one or more domains separated by commas. Leave blank to allow all domains (not recommended for production).",
        "PLACEHOLDER": "example.com, www.example.com, app.example.com"
      },
      "ALLOW_MOBILE_WEBVIEW": {
        "LABEL": "Enable widget in mobile apps",
        "SUBTITLE": "Check this if you embed the widget in iOS or Android apps. Mobile apps don't send domain information, so they would be blocked by domain restrictions unless this is enabled."
      },
      "IDENTITY_VALIDATION": {
        "TITLE": "Identity Validation",
        "DESCRIPTION": "Verify user authenticity by generating secure tokens. This prevents unauthorized users from impersonating others in your chat.",
        "SECRET_KEY": "Secret Key",
        "VIEW_DOCS": "View documentation",
        "REQUIRE_LABEL": "Require identity validation for all conversations",
        "REQUIRE_DESCRIPTION": "When enabled, users must provide a valid identity token to start conversations. Requests without valid tokens will be rejected."
      },
      "INBOX_AGENTS": "Agentes",
      "INBOX_AGENTS_SUB_TEXT": "Añadir o quitar agentes de esta bandeja de entrada",
      "AGENT_ASSIGNMENT": "Asignación de conversación",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Actualizar configuración de la asignación de conversación",
      "UPDATE": "Actualizar",
      "ENABLE_EMAIL_COLLECT_BOX": "Activar caja de recolección de correo electrónico",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Activar o desactivar la caja de recolección de correo electrónico",
      "AUTO_ASSIGNMENT": "Activar asignación automática",
      "SENDER_NAME_SECTION": "Habilitar nombre del agente en el correo electrónico",
      "SENDER_NAME_SECTION_TEXT": "Habilitar/Deshabilitar mostrando el nombre del agente en el correo electrónico, si está deshabilitado, mostrará el nombre del negocio",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Habilitar continuidad de conversación por correo electrónico",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Las conversaciones continuarán por correo electrónico si la dirección de correo electrónico de contacto está disponible.",
      "ENABLE_CONTINUITY_VIA_EMAIL_DISABLED_TEXT": "This feature is available on a paid plan. Upgrade to enable conversation continuity via email.",
      "LOCK_TO_SINGLE_CONVERSATION": "Conversation Routing",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Configure conversation creation for existing contacts",
      "INBOX_UPDATE_TITLE": "Ajustes de la Bandeja de Entrada",
      "INBOX_UPDATE_SUB_TEXT": "Actualizar la configuración de tu bandeja de entrada",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Activar o desactivar la asignación automática de nuevas conversaciones a los agentes añadidos a esta bandeja de entrada.",
      "HMAC_VERIFICATION": "Validación de identidad de usuario",
      "HMAC_DESCRIPTION": "Para validar la identidad del usuario, puede pasar un `identifier_hash` para cada usuario. Puedes generar un hash HMAC sha256 usando el `identifier` con la clave que se muestra aquí.",
      "HMAC_LINK_TO_DOCS": "Puedes leer más aquí.",
      "HMAC_MANDATORY_VERIFICATION": "Forzar validación de identidad de usuario",
      "HMAC_MANDATORY_DESCRIPTION": "Si está activado, las peticiones que no tengan el `identifier_hash` serán rechazadas.",
      "INBOX_IDENTIFIER": "Identificador de bandeja de entrada",
      "INBOX_IDENTIFIER_SUB_TEXT": "Usa el token `inbox_identifier` que se muestra aquí para autenticar tus clientes API.",
      "FORWARD_EMAIL_TITLE": "Reenviar al correo",
      "FORWARD_EMAIL_SUB_TEXT": "Empieze a reenviar su emails a la siguiente dirección de email.",
      "FORWARD_EMAIL_NOT_CONFIGURED": "Forwarding emails to your inbox is currently disabled on this installation. To use this feature, it must be enabled by your administrator. Please get in touch with them to proceed.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Permitir mensajes después de la conversación resuelta",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Permitir a los usuarios finales enviar mensajes incluso después de que la conversación sea resuelta.",
      "WHATSAPP_SECTION_SUBHEADER": "Esta clave de API se utiliza para la integración con las APIs de WhatsApp.",
      "WHATSAPP_SECTION_UPDATE_SUBHEADER": "Introduzca la clave actualizada para la integración con las API de WhatsApp.",
      "WHATSAPP_SECTION_TITLE": "Clave de API",
      "WHATSAPP_SECTION_UPDATE_TITLE": "Actualizar Clave API",
      "WHATSAPP_SECTION_UPDATE_PLACEHOLDER": "Introduzca aquí la nueva Clave API",
      "WHATSAPP_SECTION_UPDATE_BUTTON": "Actualizar",
      "WHATSAPP_EMBEDDED_SIGNUP_TITLE": "WhatsApp Embedded Signup",
      "WHATSAPP_EMBEDDED_SIGNUP_SUBHEADER": "This inbox is connected through WhatsApp embedded signup.",
      "WHATSAPP_EMBEDDED_SIGNUP_DESCRIPTION": "You can reconfigure this inbox to update your WhatsApp Business settings.",
      "WHATSAPP_RECONFIGURE_BUTTON": "Reconfigure",
      "WHATSAPP_CONNECT_TITLE": "Connect to WhatsApp Business",
      "WHATSAPP_CONNECT_SUBHEADER": "Upgrade to WhatsApp embedded signup for easier management.",
      "WHATSAPP_CONNECT_DESCRIPTION": "Connect this inbox to WhatsApp Business for enhanced features and easier management.",
      "WHATSAPP_CONNECT_BUTTON": "Conectar",
      "WHATSAPP_CONNECT_SUCCESS": "Successfully connected to WhatsApp Business!",
      "WHATSAPP_CONNECT_ERROR": "Failed to connect to WhatsApp Business. Please try again.",
      "WHATSAPP_RECONFIGURE_SUCCESS": "Successfully reconfigured WhatsApp Business!",
      "WHATSAPP_RECONFIGURE_ERROR": "Failed to reconfigure WhatsApp Business. Please try again.",
      "WHATSAPP_APP_ID_MISSING": "WhatsApp App ID is not configured. Please contact your administrator.",
      "WHATSAPP_CONFIG_ID_MISSING": "WhatsApp Configuration ID is not configured. Please contact your administrator.",
      "WHATSAPP_LOGIN_CANCELLED": "WhatsApp login was cancelled. Please try again.",
      "WHATSAPP_WEBHOOK_TITLE": "Token de verificación del Webhook",
      "WHATSAPP_WEBHOOK_SUBHEADER": "Este token se utiliza para verificar la autenticidad del extremo del webhook.",
      "WHATSAPP_TEMPLATES_SYNC_TITLE": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUBHEADER": "Manually sync message templates from WhatsApp to update your available templates.",
      "WHATSAPP_TEMPLATES_SYNC_BUTTON": "Sync Templates",
      "WHATSAPP_TEMPLATES_SYNC_SUCCESS": "Templates sync initiated successfully. It may take a couple of minutes to update.",
      "WHATSAPP_CALLING_ENABLED": {
        "LABEL": "Enable voice calling",
        "DESCRIPTION": "Allow agents to start and receive WhatsApp voice calls on this inbox. Available only on embedded-signup WhatsApp Cloud channels with calling permission granted by Meta."
      },
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Actualizar configuración de Formulario de Chat"
    },
    "HELP_CENTER": {
      "LABEL": "Centro de ayuda",
      "PLACEHOLDER": "Seleccione Centro de Ayuda",
      "SELECT_PLACEHOLDER": "Seleccione Centro de Ayuda",
      "NONE": "Ninguna",
      "REMOVE": "Eliminar Centro de Ayuda",
      "SUB_TEXT": "Adjuntar un Centro de Ayuda con la bandeja de entrada"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Límite de asignación automática",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Por favor ingrese un valor mayor a 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limite la cantidad máxima de conversaciones de esta bandeja de entrada que se pueden asignar automáticamente a un agente"
    },
    "ASSIGNMENT": {
      "TITLE": "Asignación de conversación",
      "DESCRIPTION": "Automatically assign incoming conversations to available agents based on assignment policies",
      "ENABLE_AUTO_ASSIGNMENT": "Enable automatic conversation assignment",
      "DEFAULT_RULES_TITLE": "Default assignment rules",
      "DEFAULT_RULES_DESCRIPTION": "Using the default assignment behavior for all conversations",
      "DEFAULT_RULE_1": "Earliest created conversations first",
      "DEFAULT_RULE_2": "Round robin distribution",
      "CUSTOMIZE_WITH_POLICY": "Customize with assignment policy",
      "USING_POLICY": "Using custom assignment policy for this inbox",
      "CUSTOMIZE_POLICY": "Customize with assignment policy",
      "DELETE_POLICY": "Delete policy",
      "POLICY_LABEL": "Assignment policy",
      "ASSIGNMENT_ORDER_LABEL": "Assignment Order",
      "ASSIGNMENT_METHOD_LABEL": "Assignment Method",
      "POLICY_STATUS": {
        "ACTIVE": "Activo",
        "INACTIVE": "Inactive"
      },
      "PRIORITY": {
        "EARLIEST_CREATED": "Earliest created",
        "LONGEST_WAITING": "Longest waiting"
      },
      "METHOD": {
        "ROUND_ROBIN": "Round robin",
        "BALANCED": "Balanced assignment"
      },
      "UPGRADE_PROMPT": "Custom assignment policies are available on the Business plan",
      "UPGRADE_TO_BUSINESS": "Upgrade to Business",
      "DEFAULT_POLICY_LINKED": "Default policy linked",
      "DEFAULT_POLICY_DESCRIPTION": "Link a custom assignment policy to customize how conversations are assigned to agents in this inbox.",
      "LINK_EXISTING_POLICY": "Link existing policy",
      "CREATE_NEW_POLICY": "Create new policy",
      "NO_POLICIES": "No assignment policies found",
      "VIEW_ALL_POLICIES": "View all policies",
      "CURRENT_BEHAVIOR": "Currently using default assignment behavior:",
      "LINK_SUCCESS": "Assignment policy linked successfully",
      "LINK_ERROR": "Failed to link assignment policy"
    },
    "ASSIGNMENT_POLICY": {
      "DELETE_CONFIRM_TITLE": "Delete assignment policy?",
      "DELETE_CONFIRM_MESSAGE": "Are you sure you want to remove this assignment policy from this inbox? The inbox will revert to default assignment rules.",
      "CANCEL": "Cancelar",
      "CONFIRM_DELETE": "Eliminar",
      "DELETE_SUCCESS": "Assignment policy removed successfully",
      "DELETE_ERROR": "Failed to remove assignment policy"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reautorizar",
      "SUBTITLE": "Su conexión de Facebook expiró, por favor reconecte si página de Facebook para continuar con el servicio",
      "MESSAGE_SUCCESS": "Reconección satisfactoria",
      "MESSAGE_ERROR": "Se presento un error, por favor inténtelo de nuevo"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Los formularios de Pre Chat le permiten capturar la información del usuario antes de que comiencen la conversación con usted.",
      "SET_FIELDS": "Campos del formulario del chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Campos",
        "LABEL": "Etiqueta",
        "PLACE_HOLDER": "Marca de posición",
        "KEY": "Llave",
        "TYPE": "Tipo",
        "REQUIRED": "Requerido"
      },
      "ENABLE": {
        "LABEL": "Activar formulario de pre-chat",
        "OPTIONS": {
          "ENABLED": "Si",
          "DISABLED": "No"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Mensaje de prechat",
        "PLACEHOLDER": "Este mensaje sería visible para los usuarios junto con el formulario"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Los visitantes deben proporcionar su nombre y dirección de correo electrónico antes de iniciar el chat"
      }
    },
    "CSAT": {
      "TITLE": "Habilitar Encuesta de Satisfacción",
      "SUBTITLE": "Automatically trigger CSAT surveys at the end of conversations to understand how customers feel about their support experience. Track satisfaction trends and identify areas for improvement over time.",
      "DISPLAY_TYPE": {
        "LABEL": "Display type"
      },
      "MESSAGE": {
        "LABEL": "Mensaje",
        "PLACEHOLDER": "Please enter a message to show users with the form"
      },
      "BUTTON_TEXT": {
        "LABEL": "Button text",
        "PLACEHOLDER": "Please rate us"
      },
      "LANGUAGE": {
        "LABEL": "Idioma",
        "PLACEHOLDER": "Select template language"
      },
      "MESSAGE_PREVIEW": {
        "LABEL": "Message preview",
        "TOOLTIP": "This may vary slightly when rendered on WhatsApp's platform."
      },
      "TEMPLATE_STATUS": {
        "APPROVED": "Approved by WhatsApp",
        "PENDING": "Pending WhatsApp approval",
        "REJECTED": "Meta rejected the template",
        "DEFAULT": "Needs WhatsApp approval",
        "NOT_FOUND": "The template does not exist in the Meta platform."
      },
      "TEMPLATE_CREATION": {
        "SUCCESS_MESSAGE": "WhatsApp template created successfully and sent for approval",
        "ERROR_MESSAGE": "Failed to create WhatsApp template"
      },
      "TEMPLATE_UPDATE_DIALOG": {
        "TITLE": "Edit survey details",
        "DESCRIPTION": "We will delete the previous template and make a new one which will be sent again for WhatsApp approval",
        "CONFIRM": "Create new template",
        "CANCEL": "Volver"
      },
      "UTILITY_ANALYZER": {
        "ACTION": "Check utility fit",
        "HELPER_NOTE": "Check this message before submission to improve Utility fit. The system creates a dedicated CSAT template with buttons for reporting and submits it as Utility; Meta may still reclassify it as Marketing based on content.",
        "RESULT_LABEL": "Meta category prediction",
        "GUIDANCE_NOTE": "This is a guidance check, not a guarantee of Meta approval.",
        "SUGGESTION_LABEL": "Suggested utility-safe rewrite",
        "APPLY": "Use this rewrite",
        "ERROR_MESSAGE": "Couldn't analyze the message. Please try again.",
        "CLASSIFICATION": {
          "LIKELY_UTILITY": "Likely Utility",
          "LIKELY_MARKETING": "Likely Marketing",
          "UNCLEAR": "Needs clarification"
        }
      },
      "SURVEY_RULE": {
        "LABEL": "Survey rule",
        "DESCRIPTION_PREFIX": "Send the survey if the conversation",
        "DESCRIPTION_SUFFIX": "any of the labels",
        "OPERATOR": {
          "CONTAINS": "contiene",
          "DOES_NOT_CONTAINS": "no contiene"
        },
        "SELECT_PLACEHOLDER": "select labels"
      },
      "NOTE": "Note: CSAT surveys are sent only once per conversation",
      "WHATSAPP_NOTE": "Note: When you save, the system creates a dedicated CSAT template in WhatsApp (used to capture rating and feedback in reports) and submits it as Utility for approval. Meta may still classify it as Marketing based on content. After approval, surveys are sent only once per conversation as per the survey rule.",
      "API": {
        "SUCCESS_MESSAGE": "CSAT settings updated successfully",
        "ERROR_MESSAGE": "We couldn't update CSAT settings. Please try again later."
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Establecer su disponibilidad",
      "SUBTITLE": "Establezca su disponibilidad en su widget de livechat",
      "WEEKLY_TITLE": "Establecer sus horas semanales",
      "TIMEZONE_LABEL": "Seleccione la zona horaria",
      "UPDATE": "Actualice las horas de atención",
      "TOGGLE_AVAILABILITY": "Habilite la disponibilidad de atención para esta bandeja de entrada",
      "UNAVAILABLE_MESSAGE_LABEL": "Mensaje no disponible para visitantes",
      "TOGGLE_HELP": "Al habilitar el horario de atención se mostraran las horas disponibles en el \"widget\" del chat en vivo si todos los agentes están fuera de línea. Fuera de las horas disponibles los visitantes pueden ser notificado con un mensaje y una forma PreChat.",
      "DAY": {
        "DAY": "Día",
        "AVAILABILITY": "Disponibilidad",
        "HOURS": "Horas",
        "ENABLE": "Activar la disponibilidad para este día",
        "UNAVAILABLE": "No disponible",
        "VALIDATION_ERROR": "La hora de inicio debe ser antes de la hora de cierre.",
        "CHOOSE": "Elegir"
      },
      "ALL_DAY": "Todo el día"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Configura los detalles de IMAP",
      "NOTE_TEXT": "Para habilitar SMTP, por favor configure IMAP.",
      "UPDATE": "Actualizar ajustes IMAP",
      "TOGGLE_AVAILABILITY": "Habilitar configuración IMAP para esta bandeja de entrada",
      "TOGGLE_HELP": "Habilitar IMAP ayudará al usuario a recibir correo electrónico",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configuración IMAP actualizada correctamente",
        "ERROR_MESSAGE": "No se puede actualizar la configuración IMAP"
      },
      "ADDRESS": {
        "LABEL": "Dirección",
        "PLACE_HOLDER": "Dirección (Ej: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Puerto",
        "PLACE_HOLDER": "Puerto"
      },
      "LOGIN": {
        "LABEL": "Iniciar sesión",
        "PLACE_HOLDER": "Iniciar sesión"
      },
      "PASSWORD": {
        "LABEL": "Contraseña",
        "PLACE_HOLDER": "Contraseña"
      },
      "ENABLE_SSL": "Activar SSL",
      "AUTH_MECHANISM": "Autenticación"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reautorizar su cuenta MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Configura tus detalles de SMTP",
      "UPDATE": "Actualizar ajustes SMTP",
      "TOGGLE_AVAILABILITY": "Habilitar configuración SMTP para esta bandeja de entrada",
      "TOGGLE_HELP": "Habilitar SMTP ayudará al usuario a enviar correo electrónico",
      "EDIT": {
        "SUCCESS_MESSAGE": "Configuración SMTP actualizada correctamente",
        "ERROR_MESSAGE": "No se puede actualizar la configuración SMTP"
      },
      "ADDRESS": {
        "LABEL": "Dirección",
        "PLACE_HOLDER": "Dirección (Ej: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Puerto",
        "PLACE_HOLDER": "Puerto"
      },
      "LOGIN": {
        "LABEL": "Iniciar sesión",
        "PLACE_HOLDER": "Iniciar sesión"
      },
      "PASSWORD": {
        "LABEL": "Contraseña",
        "PLACE_HOLDER": "Contraseña"
      },
      "DOMAIN": {
        "LABEL": "Dominio",
        "PLACE_HOLDER": "Dominio"
      },
      "ENCRYPTION": "Cifrado",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Abrir modo de verificación SSL",
      "AUTH_MECHANISM": "Autenticación"
    },
    "NOTE": "Nota: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar del sitio web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar eliminado correctamente",
              "ERROR_MESSAGE": "Hubo un error, por favor inténtelo de nuevo"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nombre del sitio web",
          "PLACE_HOLDER": "Introduzca el nombre de su sitio web (por ejemplo: Acme Inc)",
          "ERROR": "Por favor ingrese un nombre de sitio web válido"
        },
        "WELCOME_HEADING": {
          "LABEL": "Cabecera de bienvenida",
          "PLACE_HOLDER": "¡Hola!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Bienvenido Tagline",
          "PLACE_HOLDER": "Facilitamos la conexión con nosotros. Pídanos cualquier cosa o comparte tus comentarios."
        },
        "REPLY_TIME": {
          "LABEL": "Tiempo de respuesta",
          "IN_A_FEW_MINUTES": "En algunos minutos",
          "IN_A_FEW_HOURS": "En unas horas",
          "IN_A_DAY": "En un día"
        },
        "WIDGET_COLOR_LABEL": "Color del widget",
        "WIDGET_BUBBLE": "Bubble",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position:",
        "WIDGET_BUBBLE_TYPE_LABEL": "Tipo:",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chatea con nosotros",
          "LABEL": "Launcher Title",
          "PLACE_HOLDER": "Chatea con nosotros"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Actualizar ajustes de Widget",
          "API": {
            "SUCCESS_MESSAGE": "Configuración de Widget actualizada correctamente",
            "ERROR_MESSAGE": "No se puede actualizar la configuración del widget"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Previsualizar",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Izquierda",
          "RIGHT": "Derecha"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Estándar",
          "EXPANDED_BUBBLE": "Burbuja expandida"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Predeterminado",
        "CHAT": "Chat mode"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Normalmente responde en unos minutos",
        "IN_A_FEW_HOURS": "Normalmente responde en unas pocas horas",
        "IN_A_DAY": "Normalmente responde en un día"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Iniciar conversación",
        "CHAT_INPUT_PLACEHOLDER": "Escribe tu mensaje"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Estamos en línea",
          "OFFLINE": "Estamos ausentes en este momento"
        },
        "USER_MESSAGE": "Hola",
        "AGENT_MESSAGE": "Hola"
      },
      "BRANDING_TEXT": "Desarrollado por Chatwoot",
      "SCRIPT_SETTINGS": "\n      window.chatwootSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Connect with Microsoft"
      },
      "GOOGLE": {
        "TITLE": "Google",
        "DESCRIPTION": "Connect with Google"
      },
      "OTHER_PROVIDERS": {
        "TITLE": "Otros proveedores",
        "DESCRIPTION": "Connect with Other Providers"
      }
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Sitio web",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal API",
      "INSTAGRAM": "Instagram",
      "TIKTOK": "TikTok",
      "VOICE": "Voice"
    }
  }
}
